<form action="">
    <div class="row">
        <div class="col-12">Name</div>
        <dx-text-box class="col-12 m-2" [(value)]="form.name"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-6"></div>
        <div class="col-6">
            <dx-button class="w-100 h-100" type="success" (onClick)="onSaveHandler()">
                Save
            </dx-button>
        </div>
    </div>
</form>